import { render, staticRenderFns } from "./SubstitutionPage.vue?vue&type=template&id=f75de954&scoped=true&lang=pug&"
import script from "./SubstitutionPage.vue?vue&type=script&lang=ts&"
export * from "./SubstitutionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75de954",
  null
  
)

export default component.exports